"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureStep = exports.StepIcon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("./shared/styles");

var _excluded = ["icon"],
    _excluded2 = ["icon", "inverse", "title", "description", "link"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "endatzh5"
} : {
  target: "endatzh5",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "ys8oyt",
  styles: "display:flex;flex-direction:column;align-items:center;max-width:480px;margin-top:3rem;margin-bottom:4rem;margin-left:auto;margin-right:auto"
} : {
  name: "ys8oyt",
  styles: "display:flex;flex-direction:column;align-items:center;max-width:480px;margin-top:3rem;margin-bottom:4rem;margin-left:auto;margin-right:auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Guide = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "endatzh4"
} : {
  target: "endatzh4",
  label: "Guide"
})("background:", function (props) {
  return props.inverse ? 'linear-gradient(rgba(255 255 255 / 0%), rgba(255 255 255 / 10%))' : 'linear-gradient(rgba(0 0 0 / 0%), rgba(0 0 0 / 10%))';
}, ";width:2px;height:106px;margin-bottom:6px;");
var StepIconWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "endatzh3"
} : {
  target: "endatzh3",
  label: "StepIconWrapper"
})("display:block;width:40px;height:40px;border-radius:100%;padding:10px;margin-bottom:1.25rem;background-color:", _styles.color.green, ";color:", _styles.color.lightest, ";display:flex;align-items:center;justify-content:center;svg{color:", _styles.color.lightest, ";width:24px;height:24px;}");
var StepIcon = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'check' : _ref$icon,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StepIconWrapper, (0, _extends2["default"])({
    ref: ref
  }, props), /*#__PURE__*/_react["default"].createElement(_designSystem.Icon, {
    icon: icon
  }));
});
exports.StepIcon = StepIcon;
StepIcon.displayName = 'StepIcon';
var Heading = (0, _theming.styled)("h3", process.env.NODE_ENV === "production" ? {
  target: "endatzh2"
} : {
  target: "endatzh2",
  label: "Heading"
})(_styles.marketing.subheading, ";color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";text-align:center;margin-bottom:0.75rem;");
var Description = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "endatzh1"
} : {
  target: "endatzh1",
  label: "Description"
})(_styles.marketing.textLarge, ";color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.darkest;
}, ";text-align:center;margin-bottom:1.25rem;");
var LinkWrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "endatzh0"
} : {
  target: "endatzh0",
  label: "LinkWrapper"
})(_styles.text.largeBold, ";");

var FeatureStep = function FeatureStep(_ref2) {
  var _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? /*#__PURE__*/_react["default"].createElement(StepIcon, {
    icon: "check"
  }) : _ref2$icon,
      inverse = _ref2.inverse,
      title = _ref2.title,
      description = _ref2.description,
      link = _ref2.link,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, props, /*#__PURE__*/_react["default"].createElement(Guide, {
    inverse: inverse
  }), icon, /*#__PURE__*/_react["default"].createElement(Heading, {
    inverse: inverse
  }, title), /*#__PURE__*/_react["default"].createElement(Description, {
    inverse: inverse
  }, description), /*#__PURE__*/_react["default"].createElement(LinkWrapper, null, link));
};

exports.FeatureStep = FeatureStep;